var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { EMFFilterType, } from "../entities/MutualFundsSchemesEntity";
var mfSubFilters = function (title, value, filterType, enableSearchForFilter, parentClassName, shouldValidate, placeholder, maxInputLength, showSuffixInInput) {
    if (enableSearchForFilter === void 0) { enableSearchForFilter = false; }
    if (parentClassName === void 0) { parentClassName = ""; }
    if (shouldValidate === void 0) { shouldValidate = false; }
    if (placeholder === void 0) { placeholder = ""; }
    if (showSuffixInInput === void 0) { showSuffixInInput = true; }
    return {
        title: title,
        // list,
        value: value,
        filterType: filterType,
        enableSearchForFilter: enableSearchForFilter,
        parentClassName: parentClassName,
        shouldValidate: shouldValidate,
        placeholder: placeholder,
        maxInputLength: maxInputLength,
        showSuffixInInput: showSuffixInInput,
    };
};
export var mutualFundFilterMapper = function (filters, tabsToFilter) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (tabsToFilter === void 0) { tabsToFilter = []; }
    var newFilter = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (!tabsToFilter.includes("category") && {
        category: __assign(__assign({}, mfSubFilters("Category", "subCatCode", EMFFilterType.CHECKBOX)), { list: (_b = (_a = filters === null || filters === void 0 ? void 0 : filters.data) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.map(function (item, index) {
                var _a;
                return {
                    label: (React.createElement("span", null,
                        item.name,
                        " (",
                        item.count,
                        ")")),
                    searchKey: item.name,
                    value: (_a = item.value) !== null && _a !== void 0 ? _a : item.id,
                };
            }) }),
    })), (!tabsToFilter.includes("schemeType") && {
        schemeType: {
            title: "Scheme Type",
            value: "schemeType",
            filterType: EMFFilterType.NESTED_RADIO,
            nestedFilters: [
                __assign(__assign({}, mfSubFilters("Scheme Type", "schemeType", EMFFilterType.RADIO)), { list: (_d = (_c = filters === null || filters === void 0 ? void 0 : filters.data) === null || _c === void 0 ? void 0 : _c.schemePlan) === null || _d === void 0 ? void 0 : _d.map(function (item) {
                        return { label: item.name, value: item.name };
                    }) }),
                __assign(__assign({}, mfSubFilters("Return Option", "schemePlan", EMFFilterType.RADIO)), { list: (_f = (_e = filters === null || filters === void 0 ? void 0 : filters.data) === null || _e === void 0 ? void 0 : _e.schemeType) === null || _f === void 0 ? void 0 : _f.map(function (item) {
                        return { label: item.name, value: item.name };
                    }) }),
            ],
        },
    })), (!tabsToFilter.includes("amcName") && {
        amcName: __assign(__assign({}, mfSubFilters("Fund House", "amcName", EMFFilterType.CHECKBOX, true, "", false, "Search by Fund House")), { list: (_h = (_g = filters === null || filters === void 0 ? void 0 : filters.data) === null || _g === void 0 ? void 0 : _g.amcName) === null || _h === void 0 ? void 0 : _h.map(function (item) {
                var _a;
                return {
                    label: (React.createElement("span", null,
                        item.name,
                        " (",
                        item.count,
                        ")")),
                    searchKey: item.name,
                    value: (_a = item.name) !== null && _a !== void 0 ? _a : item.id,
                };
            }) }),
    })), (!tabsToFilter.includes("rating") && {
        rating: __assign(__assign({}, mfSubFilters("Ratings", "rating", EMFFilterType.CHECKBOX)), { list: (_k = (_j = filters === null || filters === void 0 ? void 0 : filters.data) === null || _j === void 0 ? void 0 : _j.rating) === null || _k === void 0 ? void 0 : _k.map(function (item) {
                var _a;
                return {
                    label: (React.createElement("span", { className: "d-flex align-items-center gap-1 rating-checkbox-label" },
                        React.createElement("span", null, item.name),
                        React.createElement("i", { className: "edel-icon-star-filled" }))),
                    searchKey: item.name,
                    value: (_a = item.name) !== null && _a !== void 0 ? _a : item.id,
                };
            }) }),
    })), (!tabsToFilter.includes("riskValue") && {
        riskValue: __assign(__assign({}, mfSubFilters("Risk Value", "riskValue", EMFFilterType.CHECKBOX)), { list: (_m = (_l = filters === null || filters === void 0 ? void 0 : filters.data) === null || _l === void 0 ? void 0 : _l.riskValue) === null || _m === void 0 ? void 0 : _m.map(function (item) {
                var _a;
                return {
                    label: React.createElement("span", null, item.name),
                    searchKey: item.name,
                    value: (_a = item.value) !== null && _a !== void 0 ? _a : item.id,
                };
            }) }),
    })), (!tabsToFilter.includes("1yCagr") && {
        "1yCagr": mfSubFilters("1Y CAGR", "year1", EMFFilterType.RANGE, undefined, undefined, true),
    })), (!tabsToFilter.includes("3yCagr") && {
        "3yCagr": mfSubFilters("3Y CAGR", "year3", EMFFilterType.RANGE, undefined, undefined, true),
    })), (!tabsToFilter.includes("5yCagr") && {
        "5yCagr": mfSubFilters("5Y CAGR", "year5", EMFFilterType.RANGE, undefined, undefined, true),
    })), (!tabsToFilter.includes("aumSize") && {
        aumSize: mfSubFilters("Aum Size (Cr)", "fundSize", EMFFilterType.RANGE, undefined, undefined, true, "Enter amount", 14, false),
    })), (!tabsToFilter.includes("expenseRatio") && {
        expenseRatio: mfSubFilters("Expense Ratio", "expenseRatio", EMFFilterType.RANGE, undefined, undefined, true),
    }));
    return newFilter;
};
